import { createContext } from 'react';

type RoleName = 'Admin' | 'Contributor' | 'Editor' | 'Publisher' | 'Translator';

export type TrackDetails = Record<string, unknown>;

export type UserTrack = {
  userId: string;
  details?: TrackDetails;
  userRole: RoleName;
};

export type EventTrack = {
  event: string;
  details?: TrackDetails;
  userContextRole?: RoleName;
  accountId?: string;
};

export type GroupTrack = {
  groupId: string;
  details?: TrackDetails;
};

export type PageTrack = {
  category: string;
  details?: TrackDetails;
};

export type SegmentTracking = {
  identifyUser: (track: UserTrack) => unknown;
  trackGroup: (track: GroupTrack) => unknown;
  trackEvent: (track: EventTrack) => unknown;
  trackPage: (track: PageTrack) => unknown;
  isDisabled: boolean | undefined;
  disable: () => unknown;
  enable: () => unknown;
  clear: () => unknown;
};

export const NOOP_TRACKING: SegmentTracking = {
  identifyUser: () => null,
  trackGroup: () => null,
  trackEvent: () => null,
  trackPage: () => null,
  isDisabled: false,
  enable: () => null,
  disable: () => null,
  clear: () => null,
};

export const TrackingContext = createContext<SegmentTracking>(NOOP_TRACKING);
